import type { HTMLAttributes } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

const badge = tv({
  base: "inline-flex w-fit items-center rounded-4x",
  variants: {
    tone: { neutral: "", brand: "", success: "", warning: "", danger: "" },
    variant: { subtle: "", solid: "text-fg-inverted" },
    size: { sm: "px-150 py-50 text-body-sm font-medium", md: "px-200 py-100 text-body font-semibold" },
  },
  compoundVariants: [
    { variant: "subtle", tone: "neutral", class: "bg-surface-subtle text-fg" },
    { variant: "subtle", tone: "brand", class: "bg-surface-brand-subtle text-fg-brand" },
    { variant: "subtle", tone: "success", class: "bg-surface-success-subtle text-fg-success-deep" },
    { variant: "subtle", tone: "warning", class: "bg-surface-warning-subtle text-fg-warning" },
    { variant: "subtle", tone: "danger", class: "bg-error-fill text-error-text" },
    { variant: "solid", tone: "neutral", class: "bg-surface-inverse text-fg-on-inverse" },
    { variant: "solid", tone: "brand", class: "bg-surface-brand" },
    { variant: "solid", tone: "success", class: "bg-surface-success" },
    { variant: "solid", tone: "warning", class: "bg-surface-warning" },
    { variant: "solid", tone: "danger", class: "bg-surface-danger" },
  ],
  defaultVariants: { tone: "brand", variant: "subtle", size: "md" },
})

export const Badge = ({ tone, variant, size, className, children, ...rest }: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badge>) => (
  <span className={badge({ tone, variant, size, className })} {...rest}>
    {children}
  </span>
)
